export const getMaterialDropdownOptions = (data) => {
  // Find the object with "typeofDropDown" as "material"
  const materialDropdown = data?.find(
    (item) => item?.typeofDropDown === 'material'
  );

  if (!materialDropdown || !materialDropdown?.materialsNewList) {
    return [];
  }

  // Create a list of unique categoryKey values as dropdown options
  const options = materialDropdown?.materialsNewList
    .filter(
      (item) =>
        typeof item?.category === 'string' && item?.category.trim() !== ''
    )
    .map((item) => ({ label: item?.category, value: item?.category }));

  // Remove duplicate categoryKeys
  return Array.from(
    new Map(options.map((option) => [option.value, option])).values()
  );
};

export const getSubCategoryDropdownOptions = ({ data, categoryValue }) => {
  // Find the object with "typeofDropDown" as "material"
  const materialDropdown = data?.find(
    (item) => item.typeofDropDown === 'material'
  );

  if (!materialDropdown || !materialDropdown.materialsNewList) {
    return [];
  }
  // Filter materials that match the given category value
  const filteredMaterials = materialDropdown.materialsNewList.filter(
    (item) => item.category === categoryValue
  );

  // Create dropdown options with "subCategory" as label and value
  const options = filteredMaterials.map((item) => ({
    label: item.subCategory,
    value: item.subCategory,
  }));

  // Remove duplicate subCategories
  return Array.from(
    new Map(options.map((option) => [option.value, option])).values()
  );
};

export const getMaterialNameDropdownOptions = ({ data, subCategoryValue }) => {
  // Find the object with "typeofDropDown" as "material"
  const materialDropdown = data.find(
    (item) => item.typeofDropDown === 'material'
  );

  if (!materialDropdown || !materialDropdown.materialsNewList) {
    return [];
  }

  // Filter materials that match the given subCategory value
  const filteredMaterials = materialDropdown.materialsNewList.filter(
    (item) => item.subCategory === subCategoryValue
  );

  // Create dropdown options with "label" and "materialValue"
  return filteredMaterials.map((item) => ({
    label: item.label,
    value: item.id,
  }));
};

export const getMaterialIdsByCategory = (data, categoryValue) => {
  // Find the object with "typeofDropDown" as "material"
  const materialDropdown = data.find(
    (item) => item.typeofDropDown === 'material'
  );

  if (!materialDropdown || !materialDropdown.materialsNewList) {
    return [];
  }

  // Filter materials that match the given category value
  const filteredMaterials = materialDropdown.materialsNewList.filter(
    (item) => item.category === categoryValue
  );

  // Extract and return an array of "id" values
  return filteredMaterials.map((item) => item.id);
};
export const getMaterialIdsBySubCategory = (data, materialType) => {
  // Find the object with "typeofDropDown" as "material"
  const materialDropdown = data.find(
    (item) => item.typeofDropDown === 'material'
  );

  if (!materialDropdown || !materialDropdown.materialsNewList) {
    return [];
  }

  // Filter materials that match the given category value
  const filteredMaterials = materialDropdown.materialsNewList.filter(
    (item) => item.subCategory === materialType
  );

  // Extract and return an array of "id" values
  return filteredMaterials.map((item) => item.id);
};
